import { render, staticRenderFns } from "./SalesRecapDetails_Details.vue?vue&type=template&id=254755a7&"
import script from "./SalesRecapDetails_Details.vue?vue&type=script&lang=js&"
export * from "./SalesRecapDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports